<template>
    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이벤트명">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.leadParams.event_nm" :readonly="true" onlyNumber/>
                </template>
              </ElLabel>              
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="영업대표">
                <template #end="{id}">
                  <ElInput :id="id" ref="salesBossRef" v-model="state.leadParams.sales_boss" :maxlength="10" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="회사" :required="true">
                <template #end="{id}">
                  <div class="input-group mb-3">
                    <ElInput :id="id" ref="cmpNmRef" v-model="state.leadParams.cmp_nm" readonly/>
                  </div>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사업부명">
                <template #end="{id}">
                  <ElInput :id="id" ref="deptRef" v-model="state.leadParams.cmp_dvsn_nm" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이름" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="nameRef" v-model="state.leadParams.usr_nm" readonly/>
                </template>
              </ElLabel>
          </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="직책">
                <template #end="{id}">
                  <ElInput :id="id" ref="postionRef" v-model="state.leadParams.postion" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="휴대폰번호" :required="true">
                <template #end="{id}">
                  <ElInput :id="id" ref="mobileRef" v-model="state.leadParams.mobile" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이메일">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.leadParams.email" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <label for="" class="form-label">관심분야</label>
              <SelectCode cd_gr="ATN_CD" :matchCd="state.leadParams.attn_cd" readonly :isShow="false"/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="산업분야">
                <template #end>
                  <!-- <SelectCode cd_gr="TRD_CD" :matchCd="state.leadParams.inst_cd"
                  @return="(r) => (state.leadParams.inst_cd = r.cd_id)" /> -->
                  <TreeSelect :data-list="state.cmpCls"  v-model="state.inst_cd" disabled/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="성향" :required="true">
                <template #end="{id}">
                  <SelectCode cd_gr="TRD_CD"  ref="trendRef" :matchCd="state.leadParams.trend_cd":isShow="false" />
                </template>
              </ElLabel>
              
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="즐겨찾기">
                <template #end="{id}">
                  <ElButton
                    :id="id"
                    type="bookmarkL"
                    :active="state.leadParams.bkmark_yn == 'Y'"
                    disabled
                  >
                    즐겨찾기 추가
                  </ElButton>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="메모">
                <template #end="{id}">
                  <ElTextarea class="form-control" v-model="state.leadParams.memo" :id="id" :rows="3" disabled/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업기회 Convert/Omit" :required="true">
              <template #end="{id}">
                <SelectCode ref="omtSelectRef" chk_ess="Y" cd_gr="OMT_CD" :match-cd="state.leadParams.oprtn_cd" @return="(r) => (state.leadParams.oprtn_cd = r.cd_id)" :is-show="false"/>
              </template>
            </ElLabel>
            
          </div>
        </div>

        <div class="col-md-3"  v-if="state.leadParams.oprtn_cd === 'OMT02'" >
          <div class="mb-3">
            <ElLabel name="영업기회ID">
              <template #end="{id}">
                <ElInput ref="salesIdRef" :id="id" v-model="state.leadParams.sales_id" readonly/>
              </template>
            </ElLabel>
          </div>
        </div>

        <div class="col-md-3" v-if="state.leadParams.oprtn_cd === 'OMT03'">
          <div class="mb-3">
            <ElLabel name="Omit사유">
              <template #end="{id}">
                <ElInput ref="omitRstRef" :id="id" v-model="state.leadParams.omit_rst" readonly/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>

        <!--todo : captionList 공통컴포넌트 적용-->
        <div class="row">
          <Caption
            ref="captionRef"
            :tbId="'lead'"
            :cap_seq="state.leadParams.ld_seq"
            :readonly="true"
          />
        </div>
      </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      </div>
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
  
              <FileUpload ref="fileUploadRef" @return="res => getFileList(res)" @deleteData="res => getDeleteFile(res)" :canUpdate="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <script setup>
  import { reactive, onBeforeMount, ref} from 'vue';
  import Caption from '@/components/common/CaptionList.vue';
  import FileUpload from '@/components/common/FileUpload.vue';
  import SelectCode from "@/components/common/SelectCode.vue";
  import TreeSelect from "@/components/common/TreeSelect.vue";
  import routerCmn from '@/js/vueRouterCmn';
  import { useRouter } from "vue-router";
  import { useCodeStore } from '@/store/code'
  const codeStore = useCodeStore()
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { leadSelect, leadList } from '@/api/lead';
  import { classList } from '@/api/comp';
  import { fileList } from '@/api/file';
  
  const router = useRouter();
  const fileUploadRef = ref();
  const companyModalRef = ref();
  const mobileRef = ref(null);
  const nameRef = ref();
  const cmpNmRef = ref();
  const salesBossRef = ref();
  const postionRef = ref();
  const captionRef = ref();
  const deptRef = ref()
  const trendRef = ref()

  onBeforeMount(async () => {
    let ld_seq = history.state.ld_seq;
    getCompCls()
    if (ld_seq) {
  
      let param = {
        ld_seq: ld_seq
      }
      try {
        setIsLoading(true)
        const res = await leadSelect(param)
        let detailSm = res.rtn
        state.leadParams.ld_seq = detailSm.ld_seq
        state.leadParams.event_seq = detailSm.ev_seq
        state.leadParams.event_nm = detailSm.event_nm
        state.leadParams.usr_nm = detailSm.usr_nm
        state.leadParams.email = detailSm.email
        state.leadParams.mobile = detailSm.mobile
        state.leadParams.cmp_info_seq = detailSm.cmp_info_seq
        state.leadParams.cmp_nm = detailSm.cmp_nm
        state.leadParams.cmp_dvsn_nm = detailSm.cmp_dvsn_nm
        state.leadParams.postion = detailSm.postion
        state.leadParams.sales_boss = detailSm.sales_boss
        state.leadParams.attn_cd = detailSm.attn_cd
        state.leadParams.memo = detailSm.note
        state.leadParams.oprtn_cd = detailSm.oprtn_cd
        state.leadParams.sales_id = detailSm.sales_id
        state.leadParams.omit_rst = detailSm.omit_rst
        if(detailSm.indst_cd) state.inst_cd[`${detailSm.indst_cd}`] = true

        state.leadParams.indst_cd = detailSm.indst_cd
        state.leadParams.trend_cd = detailSm.trend_cd
        state.leadParams.enable_yn = detailSm.enable_yn
        state.leadParams.bkmark_yn = detailSm.bkmark_yn
  
        //첨부파일이 존재할경우 파일리스트 조회api 호출
        if (detailSm.file_seq_grp != '' && detailSm.file_seq_grp != null && detailSm.file_seq_grp != undefined) {
          let apiParam = {
            file_seq_grp: detailSm.file_seq_grp
          }
          try {
            const resFileList = await fileList(apiParam)
            fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
          } catch (err) {
            console.log('파일리스트 조회 api 에러', err)
            alert('파일리스트 조회에 실패했습니다.')
            throw err
          }
        }
      } catch (err) {
        console.log('리드 상세조회 api 에러', err)
        alert('리드 상세 조회에 실패했습니다.')
        routerCmn.routerPush('/sm/MSM_SA_004')
      } finally {
        setIsLoading(false)
      }
    }else{
      alert('잘못된 접근입니다.')
      router.back()
    }
  })
  
  const state = reactive({
    inst_cd : {},
    cmpCls : [],
    //즐겨찾기
    sFavorites: [
      { text: 'Y', value: 'YN001' },
      { text: 'N ', value: 'YN002' },
    ],
    Favorites: 'YN002',
    Propensities: 'TRD01',
  
  
    tmpFileList: [],
    fileParams: {
      up_path: '',
      fileListVo: []
    },
  
    //파일 첨부 데이터
    fileList: [],
  
    leadParams: {
      attch_seq: 0,
      ld_seq: '',
      event_seq:null,
      event_nm: '',
      cmp_nm : '',
      usr_nm: '',
      email: '',
      mobile: '',
      cmp_info_seq: '',
      postion: '',
      sales_boss: '',
      memo: '',
      enable_yn: 'Y',
      bkmark_yn: "N",
      trend_cd: '',
      indst_cd: {},
      del_yn: 'N',
      tmp_yn: 'N',
      cap_seq : 0,
      tb_id : 'lead',
      attachFileVO: {
        file_div_id: '10',
        file_seq: '', //추가 된 파일 seq 전송
        del_file_seq: '' // 삭제해야 할 파일 seq 전송
      },
      page_count: 1,
      unit_count: 100000,
    },
    delFileList: [],
    pageType: 'insert'
  })
  
  
  
  
  
  async function getCompCls(){
    try {
      setIsLoading(true)
      const res = await classList()
      state.cmpCls = [...res.rtn]
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  </script>